import {T_SHIRT_SUBCAT_IDS} from './constants/categoryConstants';
import {visualFiltersTest} from './constants/signalmanConstants';

const visualSubcategoryFiltersABTestEnabled = (
  isInternal,
  isSearch,
  categoryId
) => {
  return (
    !isInternal &&
    !isSearch &&
    T_SHIRT_SUBCAT_IDS.includes(categoryId) && // we may need to exclude subcats not included in figma
    visualFiltersTest === 'test'
  );
};

export default visualSubcategoryFiltersABTestEnabled;
